<template>
  <div :class="$style.wrapper">
    <div :class="$style.progress">
      <div :class="$style.progress__state" :style="{width: `${progress}%`}"></div>
    </div>
  </div>
</template>

<script>
import animatedNumber from '@/mixins/animatedNumber'

export default {
  name: 'NewProgressBar',
  mixins: [animatedNumber],
  props: {
    progress: Number,
  },
  watch: {
    progress: {
      handler(newVal) {
        this.animateNumber(newVal, 1.5)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" module>
  .wrapper{
    display: flex;
    flex-direction: column;
    .progress{
      position: relative;
      width: 100%;
      height: 0.5rem;
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.05);
      display: flex;
      &__state{
        height: 0.5rem;
        border-radius: 5px;
        width: 0;
        transition: width 1.4s;
        background: linear-gradient(180deg, #3D84ED 0%, #1B5FC5 100.09%);
      }
    }
  }
</style>
